
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg","data-v-acd4e9d4":""}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.2202 15.2808C14.5133 15.5734 14.9882 15.573 15.2808 15.2798C15.5734 14.9867 15.573 14.5118 15.2798 14.2192L14.2202 15.2808ZM7.22115 12.4423C4.33759 12.4423 2 10.1047 2 7.22115H0.5C0.5 10.9331 3.50916 13.9423 7.22115 13.9423V12.4423ZM2 7.22115C2 4.33759 4.33759 2 7.22115 2V0.5C3.50916 0.5 0.5 3.50916 0.5 7.22115H2ZM7.22115 2C10.1047 2 12.4423 4.33759 12.4423 7.22115H13.9423C13.9423 3.50916 10.9331 0.5 7.22115 0.5V2ZM12.4423 7.22115C12.4423 8.66449 11.8576 9.96985 10.9104 10.9157L11.9703 11.9771C13.1878 10.7614 13.9423 9.07869 13.9423 7.22115H12.4423ZM10.9104 10.9157C9.96495 11.8598 8.66179 12.4423 7.22115 12.4423V13.9423C9.0752 13.9423 10.7551 13.1906 11.9703 11.9771L10.9104 10.9157ZM10.9105 11.9773L14.2202 15.2808L15.2798 14.2192L11.9702 10.9156L10.9105 11.9773Z","fill":"#C0C0C8"}})])
          )
        }
      }
    